import { z } from 'zod';
import { EmailSchema } from '../common/email.schema.js';
/**
 * Organisation = a customer company that subscribes to Revcall.
 * Formerly named Client. The MongoDB collection stays `Clients` for
 * historical reasons (ADR-020), mapping happens in the adapter.
 *
 * An Organisation owns:
 *   - a Subscription (billing)
 *   - TwilioNumbers
 *   - Members (via Membership aggregates)
 *   - its own business data (prospects, calls, meetings)
 *
 * The primary identifier is `id` (Mongo ObjectId as string).
 * `email` is the historical primary key and remains unique.
 */
export const OrganisationSchema = z.object({
    id: z.string(),
    email: EmailSchema,
    companyName: z.string(),
    contactName: z.string(),
    isActive: z.boolean().default(true),
    createdDate: z.coerce.date(),
    updatedDate: z.coerce.date(),
});
/**
 * Shape accepted on POST /api/admin/organisations (super-admin only).
 */
export const CreateOrganisationInputSchema = z.object({
    email: EmailSchema,
    companyName: z.string().min(1),
    contactName: z.string().min(1),
});
//# sourceMappingURL=organisation.schema.js.map